import { useState, useEffect } from "react";

const CUSTOM = "Custom";

// Dropdown of string options; picking "Custom" reveals a text box and the typed text becomes the value.
export function CustomSelect({ options, value, onChange, placeholder = "Type your own", testId }) {
  const listed = options.filter((o) => o !== CUSTOM);
  const isCustom = (v) => !!v && !listed.includes(v);
  const [custom, setCustom] = useState(isCustom(value));
  const [text, setText] = useState(isCustom(value) && value !== CUSTOM ? value : "");

  useEffect(() => {
    setCustom((c) => (isCustom(value) ? true : value ? false : c));
    if (isCustom(value)) setText(value === CUSTOM ? "" : value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const pick = (v) => {
    if (v === CUSTOM) { setCustom(true); onChange(text.trim() || CUSTOM); }
    else { setCustom(false); onChange(v); }
  };

  return (
    <div className="space-y-2 min-w-0">
      <select value={custom ? CUSTOM : value} onChange={(e) => pick(e.target.value)} className="iks-input w-full min-w-0 px-3.5 py-2.5 text-sm" data-testid={testId}>
        {[...listed, CUSTOM].map((o) => <option key={o} value={o} className="bg-slate-900">{o}</option>)}
      </select>
      {custom && (
        <input
          autoFocus
          value={text}
          onChange={(e) => { setText(e.target.value); onChange(e.target.value.trim() || CUSTOM); }}
          placeholder={placeholder}
          maxLength={60}
          className="iks-input w-full min-w-0 px-3.5 py-2.5 text-sm"
          data-testid={testId ? `${testId}-custom` : undefined}
        />
      )}
    </div>
  );
}
